import styled from 'styled-components'

export const UploadContainer = styled.div`
  margin-top: 1rem;
  width: 100%;
  max-width: 400px;
`

export const UploadArea = styled.div<{ isDragActive?: boolean; hasFile?: boolean }>`
  border: 2px dashed ${props => props.isDragActive ? '#4F46E5' : '#E5E7EB'};
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  background: ${props => props.isDragActive ? '#EEF2FF' : '#FFF'};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: ${props => props.hasFile ? 'space-between' : 'center'};
  flex-direction: ${props => props.hasFile ? 'row' : 'column'};

  &:hover {
    border-color: #0090D3;
    background: #E6F4FB;
  }
`

export const HiddenInput = styled.input`
  display: none;
`

export const UploadIcon = styled.div`
color: #6B7280;
margin-bottom: ${(props:{hasFile?: boolean}) => props.hasFile ? '0' : '12px'};

svg {
  width: ${props => props.hasFile ? '24px' : '40px'};
  height: ${props => props.hasFile ? '24px' : '40px'};
  margin: 0 auto;
}
`

export const UploadContent = styled.div<{ hasFile?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${props => props.hasFile ? '12px' : '0'};
  flex-direction: ${props => props.hasFile ? 'row' : 'column'};
`

export const UploadText = styled.p<{ hasFile?: boolean }>`
color: #374151;
margin: 0;
font-size: 0.875rem;
${props => props.hasFile && `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`}
`

export const FileInfo = styled.div`
  margin-top: 16px;
  padding: 12px;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const FileName = styled.span`
  color: #374151;
  font-size: 0.875rem;
  margin-right: 8px;
`

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #EF4444;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #DC2626;
  }
`